<template>
    <div>
    <el-drawer
        :title="$tt('交互包')"
        :visible.sync="drawerShow"
        direction="rtl"
        size="90%"
        :wrapperClosable="false"
        :before-close="handleClose"
        :modal-append-to-body="true"
        :append-to-body="true"
        :destroy-on-close="true"
        custom-class="jhb-drawer"
    >
        <div class="jhb-container" v-if="drawerShow">
            <aside class="jhb-left">
                <div class="jhb-left-title">{{ $tt("协议列表") }}</div>
                <div class="jhb-left-scroll">
                    <button
                        v-for="item in protocolNav"
                        :key="item.value"
                        type="button"
                        :class="['jhb-nav-item', leftSelectVal === item.value && 'is-active']"
                        :title="$tt(item.label)"
                        @click="handleNodeClick(item)"
                    >
                        <span class="jhb-nav-label">{{ $tt(item.label) }}</span>
                    </button>
                </div>
            </aside>
            <section class="jhb-right">
                <div v-if="leftSelectVal === '0'" class="jhb-all-pane">
                    <div class="jhb-all-tool">
                        <el-button size="small" type="primary" icon="el-icon-plus" @click="addAllClick">
                            {{ $tt("添加协议") }}
                        </el-button>
                    </div>
                    <div class="jhb-all-table">
                        <el-table
                            :data="allDatas"
                            :border="true"
                            style="width: 100%"
                            :max-height="allTableMaxH"
                        >
                            <el-table-column
                                v-for="column in allTableColumns"
                                :key="column.value"
                                :prop="column.value"
                                :label="$tt(column.label)"
                                :min-width="column.value === 'oper' ? 160 : 110"
                                :width="column.value === 'oper' ? 160 : undefined"
                                :class-name="column.value === 'oper' ? 'table-ops-cell' : ''"
                                :label-class-name="column.value === 'oper' ? 'table-ops-cell' : ''"
                                :fixed="column.value === 'oper' ? 'right' : undefined"
                                :sortable="column.value !== 'oper'"
                                :show-overflow-tooltip="column.value !== 'oper'"
                            >
                                <template slot-scope="scope">
                                    <span v-if="column.value === 'enter_space'">{{ enter_space_text(scope.row[column.value]) }}</span>
                                    <span v-else-if="column.value === 'unicode'">{{ unicode_text(scope.row[column.value]) }}</span>
                                    <div class="table-ops" v-else-if="column.value === 'oper'">
                                        <el-button size="small" type="text" icon="el-icon-edit" @click="() => {editXiyiClick(scope.row)}">
                                            {{ $tt("编辑") }}
                                        </el-button>
                                        <el-button size="small" type="text" class="table-op-danger" icon="el-icon-delete" @click="() => {deleteXiyiClick(scope.$index)}">
                                            {{ $tt("删除") }}
                                        </el-button>
                                    </div>
                                    <span v-else>{{ scope.row[column.value] }}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div v-else class="jhb-edit-pane">
                    <div class="jhb-edit-head">
                        <el-radio-group v-model="rightTopType" @input="topTypeChange">
                            <el-radio-button label="zljset">{{ $tt("指令集设置") }}</el-radio-button>
                            <el-radio-button label="btnset">{{ $tt("按钮状态设置") }}</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div class="jhb-edit-body">
                        <DirectivesComp v-if="actualRightTopType === 'zljset'" :isJhb="true" ref="directivesCompRef" :initData="directivesDatas"></DirectivesComp>
                        <InteractionBtnComp v-else ref="interactionBtnRef" :initDatas="btnsDatas"></InteractionBtnComp>
                    </div>
                </div>
            </section>
        </div>
        <div class="dialog-footer">
            <el-button @click="handleClose">{{ $tt("取 消") }}</el-button>
            <el-button type="primary" @click="confirm">{{ $tt("确 定") }}</el-button>
        </div>
    </el-drawer>
        <el-dialog
            :title="$tt('添加协议')"
            :visible="xiyiModalShow"
            :destroy-on-close="true"
            width="700px"
            :before-close="handleXiyiModalClose"
            :modal-append-to-body="true"
            :append-to-body="true"
        >
            <el-form
                :model="xiyiData"
                ref="xiyiForm"
                label-width="100px"
                :rules="xiyiformRules"
            >
                <el-form-item :label="$tt('协议类型')" prop="send_type">
                    <el-select
                        v-model="xiyiData.send_type"
                        :placeholder="$tt('请选择')"
                    >
                        <el-option
                            v-for="item in send_type"
                            :key="item.value"
                            :label="$tt(item.label)"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <p v-if="!!xiyiData.send_type" class="send-type-tip">{{ send_type_tip_map[xiyiData.send_type] }}</p>
                </el-form-item>
                <el-form-item :label="$tt('IP访问限制')" prop="ipAdress">
                    <el-input
                        v-model="xiyiData.ipAdress"
                        :placeholder="$tt('只允许特定IP进行访问请求，不限制则无需填写')"
                    ></el-input>
                </el-form-item>
                <el-form-item :label="$tt('冻结时间')" prop="freezeTime">
                    <el-input-number
                        v-model="xiyiData.freezeTime"
                        :min="0"
                        :controls="false"
                        :precision="0"
                        :placeholder="$tt('请输入冻结时间')"
                        class="freeze-time-input"
                    ></el-input-number>
                    <span style="margin-left: 5px;">秒</span>
                </el-form-item>
                <el-form-item v-if="['udp', 'tcpip'].includes(xiyiData.send_type)" :label="$tt('消息进制')" prop="unicode">
                    <el-radio-group v-model="xiyiData.unicode">
                        <el-radio
                            v-for="item in unicodeOptions"
                            :key="item.value"
                            :label="item.value"
                        >{{item.label}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <template v-if="xiyiData.send_type === 'http'">
                    <el-form-item :label="$tt('请求方式')" prop="req_modes">
                        <el-select v-model="xiyiData.req_modes" :placeholder="$tt('请选择请求方式')" @change="reqModesChange">
                            <el-option v-for="item in req_modes_options" :key="item.value" :label="$tt(item.label)" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$tt('请求体类型')" prop="param_type" v-show="false">
                        <el-radio-group v-model="xiyiData.param_type" @change="paramTypeChange">
                            <el-radio label="1" name="param_type">{{ $tt("键值对") }}</el-radio>
                            <el-radio label="0" name="param_type">{{ $tt("json格式") }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="xiyiData.param_type === '1'" :label="$tt('请求体')"
                        prop="req_body">
                        <div class="table-div">
                            <el-table :data="xiyiData.req_body" border style="width: 100%">
                            <el-table-column v-for="cell in editableCells" :key="cell.key" :prop="cell.key" :min-width="cell.width"
                                :width="cell.key === 'oper' ? 88 : undefined"
                                :fixed="cell.key === 'oper' ? 'right' : undefined"
                                :label="$tt(cell.label)">
                                <template slot-scope="scope">
                                <div class="table-ops" v-if="cell.key === 'oper'">
                                  <el-button type="text" class="table-op-danger" icon="el-icon-delete" @click="removeDatas('req_body', scope.$index)">{{ $tt("删除") }}</el-button>
                                </div>
                                <el-input v-else :value="scope.row[cell.key]" :placeholder="cell.placeholder" @input="
                                    (v) => {
                                    onTableCellChange(v, scope.row, cell.key, 'req_body');
                                    }
                                "></el-input>
                                </template>
                            </el-table-column>
                            </el-table>
                            <el-button type="primary" @click="addDatas('req_body')" class="table-add-btn">{{ $tt("添加") }}</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item v-if="xiyiData.param_type === '0'" :label="$tt('请求体')"
                        prop="req_body_json">
                        <el-input type="textarea" :placeholder="$tt('json格式')" v-model="xiyiData.req_body_json" @change="reqBodyJsonChange"></el-input>
                    </el-form-item>
                </template>
                <el-form-item :label="xiyiData.send_type ==='http' ? $tt('预览') : $tt('消息')" prop="msg">
                    <el-input
                        v-model="xiyiData.msg"
                        :placeholder="xiyiData.send_type ==='http' ? '' : $tt('请输入消息')"
                        :disabled="xiyiData.send_type === 'http'"
                    ></el-input>
                </el-form-item>
                <el-form-item v-if="['udp', 'tcpip'].includes(xiyiData.send_type) && xiyiData.unicode === '1'" :label="$tt('回车/空格')" prop="enter_space">
                    <el-radio-group v-model="xiyiData.enter_space">
                        <el-radio
                            v-for="item in enter_space"
                            :key="item.value"
                            :label="item.value"
                        >{{item.label}}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleXiyiModalClose">{{ $tt("取 消") }}</el-button>
                <el-button type="primary" @click="xiyiModalConfirm">{{ $tt("确 定") }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { uuid, validateIp } from '../utils/utils';
import DirectivesComp from './DirectivesComp/index';
import InteractionBtnComp from './InteractionBtn/index';
import { cleanupElementPopups } from '../utils/cleanupElementPopups';
import { tt } from '@/i18n';

export default {
    data() {
        var validateIpAdress = (rule, value, callback) => {
            if (value && value.trim() !== '') {
                let isRight = validateIp(value);
                if (!isRight) {
                    callback(tt('请输入正确的IP地址'));
                    return;
                }
            }
            callback();
        };
        return {
            drawerShow: false,
            leftSelectVal: '0',
            allDatas: [],
            allTableColumns: [
                { label: '协议类型', value: 'send_type' },
                { label: '消息进制', value: 'unicode' },
                { label: '消息', value: 'msg' },
                { label: '回车/空格', value: 'enter_space' },
                { label: '操作', value: 'oper' }
            ],
            xiyiModalShow: false,
            xiyiData: this.initXiyiForm(),
            send_type: [],
            enter_space: [
                { label: '否', value: '0' },
                { label: '回车', value: '1' },
                { label: '空格', value: '2' },
                { label: '回车/换行', value: '3' },
                { label: '换行/回车', value: '4' }
            ],
            unicodeOptions: [
                { label: '字符串', value: '1' },
                { label: '16进制', value: '2' }
            ],
            req_modes_options: [
                { label: 'GET', value: '0' },
                { label: 'POST', value: '1' }
            ],
            editableCells: [
                {
                    label: "参数名",
                    key: "name",
                    placeholder: "请输入",
                    width: "3",
                },
                {
                    label: "参数值",
                    key: "value",
                    placeholder: "请输入",
                    width: "2",
                },
                {
                    label: "操作",
                    key: "oper",
                    width: "2",
                }
            ],
            xiyiformRules: {
                send_type: [
                    { required: true, message: '请选择协议类型', trigger: "change" },
                ],
                ipAdress: [
                    { validator: validateIpAdress, trigger: 'blur' }
                ],
                freezeTime: [
                    { required: true, message: '请输入冻结时间', trigger: "blur" }
                ],
                unicode: [
                    { required: true, message: '请选择消息进制', trigger: "change" }
                ],
                msg: [
                    { required: true, message: '请输入消息', trigger: "blur" },
                ],
                enter_space: [
                    { required: true, message: '请选择回车/空格', trigger: "change" },
                ],
                req_modes: [
                    { required: true, message: "请选择请求方式", trigger: "change" },
                ],
                param_type: [
                    { required: true, message: "请选择请求体类型", trigger: "change" },
                ],
                req_body_json: [
                    { required: true, message: "请添加请求体", trigger: "change" },
                ],
                req_body: [
                    { required: true, message: "请添加请求体", trigger: "change" },
                ]
            },
            rightTopType: 'zljset',
            btnTableDatas: [],
            btnTableColumn: [
                { label: '页面名称', key: 'pageName' },
                { label: '按钮名称', key: 'inputContent' },
                { label: '按钮别名', key: 'alias' },
                { label: '按压效果', key: 'btnPressType' },
                { label: '操作', key: 'oper' }
            ],
            actualRightTopType: 'zljset',
            send_type_tip_map: {
                'udp': '使用设备IP地址（关于本机中查看）+端口1088，进行请求控制，注意数据格式类型',
                'tcpip': '使用设备IP地址（关于本机中查看）+端口1077，进行请求控制，注意数据格式类型',
                'http': '使用设备IP地址（关于本机中查看）+端口1099，进行请求控制，例如：\n选择GET 请求时 例：http://192.168.3.6:1099/smart_control?command=light\n选择POST请求时 例：http://192.168.3.6:1099/smart_control'
            }
        };
    },
    components: {
        DirectivesComp,
        InteractionBtnComp
    },
    computed: {
        directivesDatas() {
            let dataInd = this.allDatas.findIndex(item => item.id == this.leftSelectVal);
            let directives = this.allDatas[dataInd].directives || [];
            return directives;
        },
        btnsDatas() {
            let dataInd = this.allDatas.findIndex(item => item.id == this.leftSelectVal);
            let btns = this.allDatas[dataInd].btns || [];
            return btns;
        },
        protocolNav() {
            const list = [{ label: '全部', value: '0' }];
            this.allDatas.forEach((item) => {
                list.push({
                    label: item.send_type + '-' + item.msg,
                    value: item.id
                });
            });
            return list;
        },
        allTableMaxH() {
            const h = typeof window !== 'undefined' ? window.innerHeight : 800;
            return Math.max(280, h - 220);
        },
        enter_space_text() {
            return (val) => {
                let item = this.enter_space.filter(a => a.value === val);
                return item && item[0] && item[0].label || '';
            };
        },
        unicode_text() {
            return (val) => {
                let item = this.unicodeOptions.filter(a => a.value === val);
                return item && item[0] && item[0].label || '';
            };
        }
    },
    watch: {
        drawerShow: function(val) {
            if (val) {
                this.getSendTypes();
            }
        }
    },
    methods: {
        addDatas(key) {
            this.xiyiData[key].push({
                name: '',
                value: '',
                id: uuid()
            });
        },
        removeDatas(formKey, i) {
            this.xiyiData[formKey].splice(i, 1);
            this.setHttpMsg();
        },
        onTableCellChange(v, row, valueKey, formKey) {
            const i = this.xiyiData[formKey].findIndex(
                (i) => i.id == row.id
            );
            this.xiyiData[formKey][i][valueKey] = v;
            // 请求体改变了，需要改变消息的值
            this.setHttpMsg();
        },
        reqModesChange() {
            if (this.xiyiData.req_modes === '0') {
                // get请求
                this.xiyiData.param_type = '1';
            } else {
                // post请求
                this.xiyiData.param_type = '0';
            }
            this.setHttpMsg();
        },
        paramTypeChange() {
            this.setHttpMsg();
        },
        reqBodyJsonChange() {
            this.setHttpMsg();
        },
        setHttpMsg() {
            let req_body = '';
            if (this.xiyiData.param_type === '1') {
                if (this.xiyiData.req_body.length !== 0) {
                    req_body = this.xiyiData.req_body.reduce((obj, item) => {
                        if (item.name && item.value) {
                            obj.push(`${item.name}=${item.value}`);
                        }
                        return obj;
                    }, []);
                    if (req_body.length !== 0) {
                        req_body = '?' + req_body.join('&');
                    } else {
                        req_body = '';
                    }
                }
            } else {
                req_body = this.xiyiData.req_body_json;
            }
            this.xiyiData.msg = req_body;
        },
        topTypeChange(val) {
            if (this.actualRightTopType === 'zljset' && this.$refs.directivesCompRef) {
                // 校验是否正确，再去切换类型
                let ret = this.$refs.directivesCompRef.getDirectivesDatas();
                if (!ret) {
                    // 有不正确的数据，切回之前的节点
                    this.$nextTick(() => {
                        this.rightTopType = 'zljset';
                    });
                    return;
                }
                this.updateDirectives(ret, 'directives');
            } else {
                let ret = this.$refs.interactionBtnRef.getDatas();
                this.updateDirectives(ret, 'btns');
            }
            this.actualRightTopType = val;
        },
        getSendTypes() {
            this.$changeLoadingState(true);
            this.$request.getTypeOptions({ type: "send_type" }).then((res) => {
                this.$changeLoadingState(false);
                if (res.status != "success") {
                    this.$message.error(res.msg);
                    return;
                }
                let datas = [];
                if (res && res.data && res.data.length !== 0) {
                    res.data.map((item) => {
                        datas.push({
                            label: item.lable,
                            value: item.value
                        });
                    });
                }
                this.send_type = datas;
            }).catch(() => {
                this.$changeLoadingState(false);
            });
        },
        initXiyiForm() {
            return {
                send_type: '',
                ipAdress: '',
                freezeTime: '',
                msg: '',
                enter_space: '0',
                unicode: '1',
                req_modes: "",
                param_type: '1',
                req_body_json: '',
                req_body: []
            };
        },
        show() {
            this.drawerShow = true;
            // 初始化数据回显
            let initData = sessionStorage.getItem("interactionPackageData");
            this.allDatas = initData ? JSON.parse(initData) : [];
        },
        handleClose() {
            this.xiyiModalShow = false;
            this.drawerShow = false;
            this.leftSelectVal = '0';
            this.allDatas = [];
            this.$nextTick(() => {
                setTimeout(() => {
                    cleanupElementPopups();
                }, 320);
            });
        },
        handleNodeClick(data) {
            if (!data || data.value === this.leftSelectVal) {
                return;
            }
            if (this.$refs.directivesCompRef) {
                let ret = this.$refs.directivesCompRef.getDirectivesDatas();
                if (!ret) {
                    return;
                }
                this.updateDirectives(ret, 'directives');
            } else if (this.$refs.interactionBtnRef) {
                let ret = this.$refs.interactionBtnRef.getDatas();
                this.updateDirectives(ret, 'btns');
            }
            this.leftSelectVal = data.value;
        },
        updateDirectives(ret, propKey) {
            let dataInd = this.allDatas.findIndex(item => item.id == this.leftSelectVal);
            if (dataInd < 0) {
                return;
            }
            this.$set(this.allDatas, dataInd, { ...this.allDatas[dataInd], [propKey]: ret });
        },
        addAllClick() {
            this.xiyiModalShow = true;
        },
        editXiyiClick(row) {
            this.xiyiData = Object.assign({}, row);
            this.xiyiModalShow = true;
        },
        deleteXiyiClick(ind) {
            this.$confirm(this.$tt('确定删除该条数据？'), this.$tt('提示'), {
                confirmButtonText: this.$tt('确定'),
                cancelButtonText: this.$tt('取消'),
                type: 'warning'
            }).then(() => {
                var id = this.allDatas[ind].id;
                if (this.leftSelectVal === id) {
                    this.leftSelectVal = '0';
                }
                this.allDatas.splice(ind, 1);
            }).catch(() => {
                // 取消
            });
        },
        handleXiyiModalClose() {
            this.xiyiModalShow = false;
            this.xiyiData = this.initXiyiForm();
        },
        xiyiModalConfirm() {
            this.$refs.xiyiForm.validate((valid) => {
                if (valid) {
                    // 验证通过
                    // 验证请求头和请求体
                    if (this.xiyiData.send_type === 'http') {
                        if (this.xiyiData.param_type === '0') {
                            var isNumber = !isNaN(Number(this.xiyiData.req_body_json));
                            if (!isNumber) {
                                try {
                                    JSON.parse(this.xiyiData.req_body_json);
                                } catch (error) {
                                    this.$message.error(this.$tt('请求体请填写正确的json格式'));
                                    return;
                                }
                            }
                        } else {
                            let isBodyEmpty = false;
                            for (let k = 0; k < this.xiyiData.req_body.length; k++) {
                                if (!this.xiyiData.req_body[k].name || !this.xiyiData.req_body[k].value) {
                                    isBodyEmpty = true;
                                }
                            }
                            if (isBodyEmpty) {
                                this.$message.error(this.$tt('请求体中存在空的值，请检查并补全'));
                                return;
                            }
                        }
                    }
                    let data = JSON.parse(JSON.stringify(this.xiyiData));
                    if (data.send_type === 'http' || (data.send_type !== 'http' && data.unicode !== '1')) {
                        data.enter_space = '';
                    }
                    if (this.xiyiData.id) {
                        // 编辑
                        let ind = this.allDatas.findIndex(a => a.id === this.xiyiData.id);
                        this.$set(this.allDatas, ind, Object.assign({}, data));
                    } else {
                        this.allDatas.push(Object.assign({}, data, {
                            id: uuid()
                        }));
                    }
                    this.handleXiyiModalClose();
                }
            });
        },
        confirm() {
            this.$confirm(this.$tt('确定要将本次交互包的改变更新吗?'), this.$tt('提示'), {
                confirmButtonText: this.$tt('确定'),
                cancelButtonText: this.$tt('取消'),
                type: 'warning'
            }).then(() => {
                // 需要将当前选中节点的数据更新下，再去保存
                if (this.$refs.directivesCompRef) {
                    // 当前有指令集，去获取数据判断下有没有不符合的数据
                    let ret = this.$refs.directivesCompRef.getDirectivesDatas();
                    if (!ret) {
                        return;
                    }
                    this.updateDirectives(ret, 'directives');
                } else if (this.$refs.interactionBtnRef) {
                    let ret = this.$refs.interactionBtnRef.getDatas();
                    this.updateDirectives(ret, 'btns');
                }
                // 执行保存，并关闭
                sessionStorage.setItem("interactionPackageData", JSON.stringify(this.allDatas)); 
                this.handleClose();
            });
        }
    }
};
</script>
<style lang="scss">
.jhb-drawer {
    display: flex;
    flex-direction: column;
    .el-drawer__header {
        margin-bottom: 0;
        padding: 16px 20px 12px;
        flex-shrink: 0;
    }
    .el-drawer__body {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        padding: 0;
    }
    .el-table__body-wrapper {
        overflow-x: hidden;
    }
}
.freeze-time-input.el-input-number {
    .el-input__inner {
        text-align: left;
    }
}
</style>
<style lang="scss" scoped>
.send-type-tip {
    margin-top: 10px;
    color: red;
    white-space: break-spaces;
}
.jhb-container {
    display: flex;
    flex-direction: row;
    flex: 1;
    min-height: 0;
    overflow: hidden;
}
.jhb-left {
    width: 220px;
    flex: 0 0 220px;
    min-height: 0;
    display: flex;
    flex-direction: column;
    border-right: 1px solid #e4e7ed;
    background: #fafbfc;
}
.jhb-left-title {
    flex-shrink: 0;
    padding: 12px 16px 8px;
    font-size: 13px;
    font-weight: 600;
    color: #303133;
}
.jhb-left-scroll {
    flex: 1;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0 8px 12px;
}
.jhb-nav-item {
    display: block;
    width: 100%;
    border: none;
    background: transparent;
    text-align: left;
    padding: 8px 10px;
    margin-bottom: 4px;
    border-radius: 6px;
    cursor: pointer;
    color: #606266;
    font-size: 13px;
    line-height: 1.4;
    &:hover {
        background: #ecf5ff;
        color: #409eff;
    }
    &.is-active {
        background: #409eff;
        color: #fff;
    }
}
.jhb-nav-label {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.jhb-right {
    flex: 1;
    min-width: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding: 12px 16px 0;
    overflow: hidden;
}
.jhb-all-pane,
.jhb-edit-pane {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.jhb-all-tool {
    flex-shrink: 0;
    margin-bottom: 12px;
}
.jhb-all-table {
    flex: 1;
    min-height: 0;
    overflow: hidden;
}
.jhb-edit-head {
    flex-shrink: 0;
    margin-bottom: 10px;
}
.jhb-edit-body {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    > * {
        flex: 1;
        min-height: 0;
        height: 100%;
    }
}
.dialog-footer {
    flex-shrink: 0;
    width: 100%;
    text-align: right;
    background: #fff;
    padding: 12px 16px 16px;
    border-top: 1px solid #ebeef5;
}
</style>
